import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b3788f20&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3788f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3788f20')) {
      api.createRecord('b3788f20', component.options)
    } else {
      api.reload('b3788f20', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b3788f20&scoped=true&", function () {
      api.rerender('b3788f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWSnXmS2WFG3/JS/comp/SearchFilterTokens.vue"
export default component.exports